<!--赖传峰-->
<!--2022/11/14-->
<!--使用 https://docs.embed.ly/reference/cards 提供的 API 展示我们无法解析的资源-->
<template>
  <ElScrollbar>
    <a
      v-if="props.url"
      :href="props.url"
      class="embedly-card"
      data-card-key="1d5c48f7edc34c54bdae4c37b681ea2b"
    />
  </ElScrollbar>
</template>

<script
  lang="ts"
  setup
>

import { onMounted } from 'vue'

const props = defineProps<{ url?: string }>()

const SCRIPT_ID = 'embedly_platform'
onMounted(() => {
  if (!props.url) return
  if (document.getElementById(SCRIPT_ID)) return
  try {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = `${document.location.protocol}//cdn.embedly.com/widgets/platform.js`
    document.body.appendChild(script)
  } catch (err) {
    console.error(err)
  }
})

</script>
